module.exports = __webpack_public_path__ + "static/media/icon-arrow-left.09f7ce4f.svg";